import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import MapComponent from "./map"; // Your map component
import { useParams } from "react-router-dom";
import { useFetch } from "../../../utils/useFetch";
import { pls_url } from "../../../api/urls";

const Tracking = () => {
  // Assume accessToken is stored in Redux; adjust selector as needed
  const accessToken = useSelector((state) => state.user.accessToken);
  const [location, setLocation] = useState({});
  const params = useParams();
  const { data } = useFetch(pls_url + `${params.id}/`);
  useEffect(() => {
    // Connect to the Socket.IO server using the access token for authentication
    const socket = io(process.env.REACT_APP_API + "/delivery", {
      // extraHeaders: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
      auth: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    socket.on("connect", () => {
      socket.emit("join_room", { room: `chat_room_${params.id}` });
    });
    socket.on("room_joined", (data) => {
      console.log("📦 Joined Room:", data);
    });
    socket.on("connect_error", (err) => {
      console.error("Connection Error:", err);
    });

    socket.on("disconnect", (reason) => {
      console.warn("Disconnected:", reason);
    });

    socket.on("location_update", (data) => {
      console.log("Message from server:", data);
      setLocation(data);
    });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, [accessToken, params.id]);

  return (
    <div>
      <MapComponent location={location} data={data} />
    </div>
  );
};

export default Tracking;
